import { useState, useCallback } from "react"
import api from "../services/api"

export function useDocuments() {
    const [documents, setDocuments] = useState([])
    const [widgets, setWidgets] = useState([])
    const [controls, setControls] = useState(null)

    const loadData = useCallback(async () => {
        try {
            const [docsRes, widgetsRes] = await Promise.all([
                api.get("/documents"),
                api.get("/widgets")
            ])
            setDocuments(docsRes.data)
            setWidgets(widgetsRes.data)
            const ctrl = widgetsRes.data.find(w => w.widgetName === "Controls")
            if (ctrl) setControls(ctrl)
        } catch (err) {
            console.error("Failed to load documents/widgets:", err)
        }
    }, [])

    return { documents, widgets, controls, loadData }
}
